import { Create, SimpleForm, TextInput, SelectInput, required, minLength } from 'react-admin';
import { Box } from '@mui/material';
import { layout } from '../styles/ds';

const ROLE_CHOICES = [
  { id: 'staff', name: 'צוות' },
  { id: 'admin', name: 'מנהל/ת' },
];

const UserCreate = () => (
  <Create title="משתמש חדש">
    <SimpleForm>
      <Box sx={layout.formGrid}>
        <TextInput source="username" label="שם משתמש" fullWidth validate={required('שדה חובה')} />
        <SelectInput source="role" label="תפקיד" choices={ROLE_CHOICES} defaultValue="staff" fullWidth />
      </Box>
      <TextInput source="password" label="סיסמא (לפחות 8 תווים)" type="password" fullWidth
        validate={[required('שדה חובה'), minLength(8, 'לפחות 8 תווים')]} />
    </SimpleForm>
  </Create>
);

export default UserCreate;
